import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDvWNuhn5U4L2sld9cbnFU4MreVabB6uKs",
  authDomain: "wedding-photo-app-4c48a.firebaseapp.com",
  projectId: "wedding-photo-app-4c48a",
  storageBucket: "wedding-photo-app-4c48a.firebasestorage.app",
  messagingSenderId: "959541305269",
  appId: "1:959541305269:web:c5233e2b93bbc7ab5283fc"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };
